<div class="cookies text-color-2 relative flex items-center justify-between py-10 pl-12 pr-16 border-box cursor-default" [class.hidden]="events.isKeyboardOpen()">
  <div class="cookies-inner flex items-center">
    <app-svg-icon name="cookie-20px" type="svg" [cssColor]="true"></app-svg-icon>
    <span (click)="onProcessLink($event)" class="ml-8" [innerHTML]="'t.we-use-cookies' | translate | safe: 'html'"></span>
  </div>
  <button class="btn btn--tertiary ml-20" (click)="cookiesAccepted()">{{'t.accept' | translate}}</button>
</div>
